import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkCustomMdlModule } from '@core/customCDK/cdkCustomMdl/cdk-custom-mdl.module';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';
import { CONFIRMATION_MODAL_DATA } from '@core/customCDK/cdkCustomMdl/tokens/confirmation-data.token';
import { CustomOtpComponent } from '../custom-otp.component';



export interface CustomOtpModal {
  otpBoxNormal: boolean;
  otpBox: number; //set count of input box's
  isSubmitBtn: boolean; //show submit button
  submitBtnName: any; //set submit button name
  submitBtnClass: any; //Set classes
  showCloseIcon: boolean; //show submit button
  isResendOTP: boolean; //show resend button
  isResendText: string; //show resend button
  resendOTPCounter: number; //set resend timmer
  dynamicResendCounter: boolean; //show resend button
  title: null | string; //show mesg send to mobile
  message: null | string; //show mesg send to mobile
  showMesgOtpSendToMobile: null | string; //show mesg send to mobile
  resetOtp: boolean;
  onlyMessage: boolean;
  placeholder: string;
}

@Component({
  selector: 'app-custom-otp-view',
  standalone: true,
  imports: [
    CommonModule,
    CdkCustomMdlModule,
    CustomOtpComponent
  ],
  templateUrl: './custom-otp-view.component.html',
  styleUrls: ['./custom-otp-view.component.scss'],
})

export class CustomOtpViewComponent implements OnInit {

  constructor(
    public dialogRef: ConfirmationModalOverlayRef,
    @Inject(CONFIRMATION_MODAL_DATA) public data: CustomOtpModal,
  ) {
    console.log(this.data);

  }
  ngOnInit(): void {

  }

  sendOtp(otp: string) {
    this.dialogRef.events.next({
      type: 'sendOtp',
      data: otp
    });
  }

  resendOtp() {
    this.dialogRef.events.next({
      type: 'resendOtp',
      data: this.data
    });
  }

  closeTemplateModal() {
    this.dialogRef.events.next({
      type: 'closeTemplateModal',
      data: this.data
    });
  }

}